import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useViewConfig } from '../../hooks/useViewConfig';
import { BASE_LAYOUT_LIST } from '../../constants/viewConfig';
import styles from './OneColumnLayout.module.css';

const OneColumnLayout = ({ header, children, className }) => {
  const BaseLayout = useViewConfig(BASE_LAYOUT_LIST);
  return (
    <BaseLayout
      header={header}
      className={classNames(styles.component, className)}
    >
      {children}
    </BaseLayout>
  );
};

OneColumnLayout.propTypes = {
  header: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
};

export default OneColumnLayout;
